import { BaseService } from 'core/services';
import DiagnosisCodeRouteService from './DiagnosisCodeRouteService';

class DiagnosisCodeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DiagnosisCodeRouteService());
    }

    async getExisting(abrv){
        const url = this.routeService.getExisting(abrv);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    async getDiagnosisCodes(resource){
        const url = this.routeService.find(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
}

export default DiagnosisCodeService;